// Todo o conteúdo editável do site. Dados reais da Dra. Inês Dias (Argoterapias).
export const SITE = {
  name: "Inês Dias",
  fullName: "Dra. Inês Dias",
  role: "Psicologia Clínica",
  tagline: "Um espaço seguro para se (re)encontrar",
  origin: "Coimbra",
  instagram: "@inesdias.psi",
  instagramUrl: "https://www.instagram.com/inesdias.psi/",
  email: "psicologa.inesdias@gmail.com",
  phone: "+351 918 227 739",
  location: "Portugal · Presencial e Online",
};

export const IMAGES = {
  heroTexture: "https://images.unsplash.com/photo-1657624332868-2159deacefa9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxzb2Z0JTIwcGluayUyMGFic3RyYWN0JTIwdGV4dHVyZSUyMGNhbG18ZW58MHx8fHwxNzg2Nzg0OTgxfDA&ixlib=rb-4.1.0&q=85",
  portrait: "/ines-dias.jpg",
  about: "/ines-about.jpg",
  office: "https://images.unsplash.com/photo-1754037783933-c25ff9f68f87?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjB0aGVyYXB5JTIwb2ZmaWNlJTIwbmF0dXJhbCUyMGxpZ2h0fGVufDB8fHx8MTc4Njc4NDk4MXww&ixlib=rb-4.1.0&q=85",
};

// Bio real (adaptada para plataforma independente)
export const ABOUT = {
  intro: "Psicóloga clínica, natural de Coimbra.",
  paragraphs: [
    "A Dra. Inês Dias realiza acompanhamento psicológico de crianças, adolescentes e adultos, com consultas presenciais, online ou ao domicílio — sempre com o objetivo de tornar o apoio acessível a quem mais precisa.",
    "Está aqui para ajudar cada pessoa a (re)descobrir o seu equilíbrio, sentido e bem-estar — mesmo quando a vida anda aos saltos.",
  ],
};

// Áreas de intervenção reais (retiradas dos posts)
export const AREAS = [
  "Trabalho centrado nas necessidades e ritmo de cada pessoa",
  "Promoção da autoestima, amor-próprio e desenvolvimento pessoal",
  "Acompanhamento em luto, separações e momentos de mudança",
  "Apoio a famílias e orientação parental",
  "Intervenção em ansiedade, depressão e stress",
  "Criação de um espaço seguro, de escuta e transformação",
  "Suporte em dificuldades escolares e comportamentais na infância",
  "Acompanhamento emocional em doenças crónicas, envelhecimento e demência",
  "Estimulação cognitiva a idosos",
  "Gestão emocional, controlo de impulsos e compulsões",
];

export const MANIFESTO = [
  { n: "01", title: "Escutar sem julgar", text: "Cada história merece um espaço onde possa existir por inteiro, ao seu ritmo e sem juízos." },
  { n: "02", title: "Compreender a raiz", text: "Trabalhamos além do sintoma, procurando o significado por trás daquilo que sente." },
  { n: "03", title: "Caminhar em conjunto", text: "A terapia é uma relação. Construímos, passo a passo, ferramentas para a sua vida." },
  { n: "04", title: "Reencontrar o equilíbrio", text: "O objetivo não é ser outra pessoa, mas voltar a sentir-se você mesma." },
];

export const TESTIMONIALS = [
  { text: "A Dra. Inês criou um espaço onde finalmente me senti ouvida. Mudou a forma como me relaciono comigo própria.", author: "M. S.", tag: "Consulta Presencial" },
  { text: "O acompanhamento ao domicílio fez toda a diferença para a minha mãe. Dedicação e carinho em cada visita.", author: "J. R.", tag: "Consulta ao Domicílio" },
  { text: "As sessões online tornaram tudo possível mesmo com a minha agenda. Empatia e profissionalismo do início ao fim.", author: "A. C.", tag: "Consulta Online" },
];

export const FAQ = [
  { q: "Como decorre a primeira sessão?", a: "A primeira avaliação é um momento de conhecimento mútuo. Falamos sobre aquilo que a/o traz à terapia e definimos, em conjunto, os objetivos do acompanhamento." },
  { q: "As consultas são confidenciais?", a: "Absolutamente. Tudo o que é partilhado em consulta é protegido pelo sigilo profissional e pelo Código Deontológico da Ordem dos Psicólogos Portugueses." },
  { q: "Atende crianças e idosos?", a: "Sim. A Dra. Inês acompanha crianças, adolescentes, adultos e idosos, em consultas presenciais, online ou ao domicílio." },
  { q: "As consultas online são igualmente eficazes?", a: "Sim. A investigação demonstra que o acompanhamento por videochamada é tão eficaz quanto o presencial, com a vantagem da flexibilidade." },
];
